module.exports = __webpack_public_path__ + "img/world.d0737b72.svg";